import React, { createContext, useContext, useReducer } from "react";

interface SideNav {
    id: string,
    name: string,
    icon: string,
    order: number,
    route: string,
    parentId: string,
    roleType: string
}

interface AuthState {
    isLogin: boolean;
    loginStatus: any;
    userProfile: null | {
        id: string,
        name?: string,
        userName?: string,
        role: any,
    },
    sideNav: SideNav[]
}

const INITIAL_STATE: AuthState = {
    isLogin: false,
    loginStatus: null,
    userProfile: null,
    sideNav: []
};

export const SET_LOGIN_STATUS = "[AUTH] SET_LOGIN_STATUS";
export const SET_LOGIN_ERROR = "[AUTH] SET_LOGIN_ERROR";
export const SET_CURRENT_USER = "[AUTH] SET_CURRENT_USER";
export const CLEAR_CURRENT_USER = "[AUTH] CLEAR_CURRENT_USER";

const reducer = (state: AuthState, action: { type: string, payload: any }): AuthState => {
    const { type, payload } = action;
    switch (type) {
        case SET_CURRENT_USER:
            const { role, ...userProfile } = payload['currentUser'];
            return {
                ...state,
                userProfile: { role, ...userProfile },
                sideNav: addCrytoWalletNav(payload),
            }
        case SET_LOGIN_STATUS:
            return { ...state, isLogin: payload };
        case CLEAR_CURRENT_USER:
            return INITIAL_STATE;
        default:
            return state;
    }
};

const addCrytoWalletNav = (payload: any) => {
    const sideNav = payload['currentUser'].role?.roleSideNavigations.map(
        (s: any) => {
            return {
                ...s.sideNavigation,
                roleType: s.roleType,
            };
        })

    if(sideNav.length > 0) {
        let newSideNav: any[] = []
        sideNav.forEach((element: any) => {
            newSideNav.push(element)
            if (element.route === '/members/kyc') {
                var newElement = { ...element }
                newElement.id = "ckox3qg94000b01k1dq2yg123"
                newElement.name = 'Cryto Wallet Transaction'
                newElement.route = '/members/crypto-wallet-transaction'
                // newElement.roleType = "RAWD"
                newSideNav.push(newElement)
            }
        });
        console.log('newSideNav', newSideNav)
        return newSideNav
    }

    return sideNav
}

const authContext = createContext<{ authState: AuthState; authDispatch: React.Dispatch<any>; }>
    ({ authState: INITIAL_STATE, authDispatch: () => null });

export const AuthProvider = ({ children }: any) => {
    const [authState, authDispatch] = useReducer(reducer, INITIAL_STATE);
    return (
        <authContext.Provider value={{ authState, authDispatch }} >
            { children}
        </authContext.Provider>
    );
}

export const useAuth = () => {
    return useContext(authContext);
}